export enum IMG_TYPES {
  LEADERBOARD = 'LeaderBoard',
  PREVIOUSROUND = 'PreviousRound',
  HISTORY = 'History',
  TOP = 'Top',
  STATS = 'Stats',
}

export enum IMG_TYPES_PT {
  LEADERBOARD = 'LeaderBoardPT',
  PREVIOUSROUND = 'PreviousRoundPT',
  HISTORY = 'HistoryPT',
  TOP = 'TopPT',
  STATS = 'StatsPT',
}

export enum AVAILABLE_CURRENCIES {
  ZAR = 'ZAR',
}

export enum JURISDICTION {
  UK = 'UK',
  ON = 'ON',
  CO = 'CO',
  X1 = 'X1',
  LT = 'LT',
  ES = 'ES',
}
